import { dispatchStatusMessageEvent } from './status-message-event';
/**
 * Do not use directly! Always use the useUpdateSuccess/Error/Info!
 *
 * Builds a stable function that emits a global status message as a native browser event.
 * This keeps the package decoupled from redux and the rest of the Famly app. Because the
 * returned function captures no React state, it can be created once at module level — the
 * consuming hooks return it directly without needing `useCallback`.
 *
 * @param statusType the kind of message to emit
 * @returns a function that emits a status message of the given type
 */
export function createUpdateMessage(statusType) {
    return (message, params = {}) => {
        var _a, _b, _c, _d;
        return dispatchStatusMessageEvent({
            message,
            statusType,
            e2eId: (_a = params.e2eId) !== null && _a !== void 0 ? _a : '',
            sticky: (_b = params.sticky) !== null && _b !== void 0 ? _b : false,
            duration: (_d = (_c = params.duration) !== null && _c !== void 0 ? _c : window.__cypressToastDuration) !== null && _d !== void 0 ? _d : 4000,
        });
    };
}
